/**
 * Icon and SVG utility functions for the stores map
 */

import { createCustomStoresMapIcon } from '../../utils/markerUtils';

/**
 * Get crime risk label based on total_crime_incidents
 * Categories: Critical (>=5000), High (>=1000), Medium (>=200), Low (>0), No Data
 */
export function getCrimeRiskLabel(crimeRate: number): string {
  if (crimeRate >= 5000) return 'Critical';
  if (crimeRate >= 1000) return 'High';
  if (crimeRate >= 200) return 'Medium';
  if (crimeRate > 0) return 'Low';
  return 'No Data';
}

/**
 * Get CSS class for crime risk badge styling
 */
export function getCrimeRiskClass(crimeRate: number): string {
  if (crimeRate >= 5000) return 'crime-risk-critical';
  if (crimeRate >= 1000) return 'crime-risk-high';
  if (crimeRate >= 200) return 'crime-risk-medium';
  if (crimeRate > 0) return 'crime-risk-low';
  return 'crime-risk-nodata';
}

/**
 * Helper function to create custom circle SVG icon with logo and labels
 * Now delegates to shared utility function for consistency
 */
export function createCustomIcon(
  labels: string[],
  isReference: boolean,
  hasP: boolean = false,
  logoDataUrl: string = '',
  brandInitial: string = 'K'
): string {
  return createCustomStoresMapIcon(labels, isReference, hasP, logoDataUrl, brandInitial);
}
